var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9249 22.9893C18.441 19.7147 23.453 17.5558 25.9607 16.5127C33.1209 13.5346 34.6087 13.0173 35.5784 13.0002C35.7917 12.9964 36.2686 13.0493 36.5775 13.2999C36.8383 13.5116 36.9101 13.7975 36.9444 13.9982C36.9788 14.1988 37.0215 14.656 36.9876 15.0131C36.5995 19.09 34.9206 28.9834 34.0665 33.5496C33.7051 35.4817 32.9934 36.1295 32.3045 36.1929C30.8072 36.3307 29.6703 35.2034 28.2201 34.2528C25.9509 32.7653 24.669 31.8393 22.4663 30.3878C19.9207 28.7103 21.5709 27.7884 23.0216 26.2816C23.4013 25.8873 29.9982 19.8869 30.1259 19.3426C30.1419 19.2745 30.1567 19.0207 30.0059 18.8867C29.8552 18.7527 29.6327 18.7985 29.4721 18.835C29.2445 18.8866 25.6194 21.2827 18.5968 26.0231C17.5678 26.7297 16.6358 27.074 15.8008 27.0559C14.8802 27.036 13.1094 26.5354 11.793 26.1075C10.1783 25.5827 8.89504 25.3052 9.00678 24.4138C9.06499 23.9495 9.70434 23.4747 10.9249 22.9893Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.abf8bae8.svg";
export { ForwardRef as ReactComponent };